import { render, staticRenderFns } from "./LoadImage.vue?vue&type=template&id=2082616a"
import script from "./LoadImage.vue?vue&type=script&lang=js"
export * from "./LoadImage.vue?vue&type=script&lang=js"
import style0 from "./LoadImage.vue?vue&type=style&index=0&id=2082616a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports